<template>
  <div class="pbar fCol aCenter jCenter">
    <!-- loading -->
    <div class="fCol jCenter aCenter" v-if="loading">
      <div class="loadingCircle" v-bind:class="{mini: mini}"></div>
      <label v-bind:class="{mini: mini}">لطفا صبر کنید</label>
      <span v-if="!mini">درحال دریافت اطلاعات</span>
    </div>
    <div class="fCol jCenter aCenter" v-if="notYet">
      <i class="material-icons-round ic s emp">search</i>
      <label>جستجو کنید</label>
      <span>اطلاعات مربوطه در فرم بالا را وارد کنید</span>
    </div>
    <div class="fCol jCenter aCenter" v-if="noContent">
      <i class="material-icons-round ic">not_interested</i>
      <label>لیست مورد نظر خالی است</label>
      <span>برای درخواست شما اطلاعات در دسترس نیست</span>
    </div>
    <div class="fCol jCenter aCenter" v-if="notFound">
      <i class="material-icons-round ic">not_interested</i>
      <label>اطلاعات یافت نشد</label>
      <span>برای درخواست شما اطلاعات در دسترس نیست</span>
    </div>
    <div class="fCol jCenter aCenter" v-if="error">
      <i class="material-icons-round ic e">report</i>
      <label>خطا در دریافت اطلاعات</label>
      <span>{{msg}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['loading', 'notYet', 'notFound', 'error', 'noContent', 'msg', 'mini'],
  data() {
    return {
    };
  },
  methods: {
    setMode() {
      // console.warn('mode changed, from pBar');
    },
  },
  watch: {
    mode() {
      this.setMode();
    },
  },
  mounted() {
    this.setMode();
  },
};
</script>

<style lang='scss' scoped>
.pbar {
  margin: 32px 0;
}
i {
  border-radius: 50%;
  padding: 8px;
}
.pbar .loadingCircle{
  width:  48px;
  height: 48px;
  border-radius: 50%;
  border: solid 2px rgba($color: #633535, $alpha: 1.0);
  border-top-color: rgba($color: #000000, $alpha: 0);
  margin-bottom: 16px;
  animation: load linear 1s infinite;
}
.pbar .loadingCircle.mini{
  width:  16px;
  height: 16px;
  border-radius: 50%;
  margin-bottom: 0;
  animation: load linear 0.5s infinite;
}

.pbar label{
  margin-top: 20px;
  font-weight: 100;
  font-size: 24px;
  color: rgba($color: #888888, $alpha: 1.0);
}
.pbar label.mini{
  margin-top: 12px;
  font-weight: 100;
  font-size: 12px;
  color: rgba($color: #888888, $alpha: 1.0);
}

.pbar span {
  font-size: 14px;
  font-weight: 200;
  color: rgba($color: #b8b8b8, $alpha: 1.0);
}

.pbar i.ic {
  font-size: 64px;
  color: rgba($color: #818181, $alpha: 1.0);
}

.pbar i.ic.e {
  font-size: 64px;
  color: rgba($color: #b44747, $alpha: 1.0) !important;
}

.pbar i.ic.s {
  font-size: 64px;
  color: rgba($color: #3d6a9c, $alpha: 1.0) !important;
}

.er {
  animation: error infinite alternate 1s linear;
}

.emp {
  animation: empty infinite 3s cubic-bezier(1, 0, 0, 1);
}

@keyframes load{
  0%{
    box-shadow: 0 0 0 0px rgba($color: #000000, $alpha: 0.05);
    transform: rotate(0deg);
  }
  100%{
    box-shadow: 0 0 0 64px rgba($color: #000000, $alpha: 0.0);
    transform: rotate(-360deg);
  }
}
@keyframes error{
  0%{
    color: #ff2210;
  }
  100%{
    color: #85231a;
  }
}
@keyframes empty{
  0%{
    box-shadow: 0 0 0 0px rgba($color: #000000, $alpha: 0.15);
    color: #858585;
  }
  100%{
    box-shadow: 0 0 0 64px rgba($color: #000000, $alpha: 0.0);
    color: #a8a8a8;
  }
}

</style>
